import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/61_card_back_chinese_palace/61_card_back_chinese_palace"
 * Contains 1 texture(s)
 */
export class CardsBacks61CardBackChinesePalaceAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/61_card_back_chinese_palace/61_card_back_chinese_palace';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '61_chinese_palace.png'
    ] as const;
}
